<div>
  <mat-card class="site-detail-data-card">
    <mat-card class="site-detail-data-card-title">
      {{ tiltData ? tiltData.positionName : "名無し" }}
    </mat-card>

    <mat-card
      class="site-detail-data-card-status {{
        tiltData?.hasManagementAlert
          ? 'status-signal-20'
          : tiltData?.attentionDate
          ? 'status-signal-3'
          : 'status-signal-1'
      }}"
    >
      {{
        tiltData?.hasManagementAlert
          ? "危険"
          : tiltData?.attentionDate
          ? "注意"
          : "安全"
      }}
    </mat-card>

    <mat-card class="site-detail-data-card-item">
      <span class="site-detail-data-card-item-title">管理基準値(mm)</span>
      <div class="site-detail-data-card-item-value">
        <span
          class="site-detail-data-card-item-value-inner"
          style="color: rgba(255, 152, 0, 1)"
        >
          {{
            tiltData?.managementStandard != null
              ? (tiltData?.managementStandard | number : ".1")
              : "-"
          }}
        </span>
      </div>
    </mat-card>
    <mat-card class="site-detail-data-card-item">
      <span class="site-detail-data-card-item-title">更新日時:</span>
      <span class="site-detail-data-card-item-date">
        <span class="site-detail-data-card-item-date-inner">
          {{ tiltData?.date ? tiltData?.date : "-" }}
        </span>
      </span>
    </mat-card>
    <mat-card class="site-detail-data-card-item">
      <span class="site-detail-data-card-item-title">変位(mm):</span>
      <div class="site-detail-data-card-item-value">
        <span
          class="site-detail-data-card-item-value-inner"
          style="color: rgba(255, 152, 0, 1)"
        >
          {{
            tiltData?.displacement != null
              ? (tiltData?.displacement | number : "1.3-3")
              : "-"
          }}
        </span>
      </div>
    </mat-card>
    <mat-card class="site-detail-data-card-item">
      <span class="site-detail-data-card-item-title">時間変位(mm/h):</span>
      <div class="site-detail-data-card-item-value">
        <span
          class="site-detail-data-card-item-value-inner"
          style="color: rgba(255, 152, 0, 1)"
        >
          {{
            tiltData?.hourlyDeltaDisplacementX != null
              ? (tiltData?.hourlyDeltaDisplacementX | number : "1.3-3")
              : "-"
          }}
        </span>
      </div>
    </mat-card>
    <mat-card class="site-detail-data-card-item">
      <span class="site-detail-data-card-item-title">電池残量(%):</span>
      <div class="site-detail-data-card-item-value">
        <span
          class="site-detail-data-card-item-value-inner"
          style="color: rgba(3, 169, 244, 1)"
        >
          {{
            tiltData?.battery != null
              ? (tiltData?.battery | number : "1.0-0")
              : "-"
          }}
        </span>
      </div>
    </mat-card>
  </mat-card>
</div>
